<template>
	<div class="main">
		<!-- 顶部操作栏 -->
		<div class="operation-bar">
			<el-form :inline="true" :model="searchForm" class="search-form">
				<el-form-item label="店铺">
					<el-select v-model="searchForm.shop" placeholder="选择店铺" style="width:200px" filterable
						@change="onShopChange">
						<el-option v-for="item in filters" :key="item.value" :label="item.text" :value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="本地父体">
					<el-select v-model="searchForm.parentName" placeholder="选择父体" style="width:280px" filterable
						clearable>
						<el-option v-for="p in parentOptions" :key="p.value" :label="p.text" :value="p.value" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch" :loading="isSending">查询</el-button>
					<el-button @click="resetSearch">重置</el-button>
				</el-form-item>
			</el-form>
			<div class="action-btns-group">
				<el-button @click="change_all" :loading="isSending18" size="small">建议置换</el-button>
				<el-button @click="jojo2" :loading="isSending18" size="small">一键采购</el-button>
				<el-button @click="allupdate" size="small">批量编辑</el-button>
				<!-- 暂时注释任务面板入口，当前页面只保留原有采购操作。 -->
				<!--
				<el-badge :value="activeTaskCount" :hidden="activeTaskCount == 0">
					<el-button @click="openTaskPanel" size="small">任务面板</el-button>
				</el-badge>
				-->
		</div>
		</div>

		<!-- 数据表格区域 -->
		<div class="table-area">
			<div class="table-header-bar">
				<span class="table-title">品名数据列表</span>
				<el-input v-model="pmFilter" placeholder="筛选本地品名" size="small" style="width:200px"
					clearable prefix-icon="el-icon-search" />
				<el-input v-model="skuFilter" placeholder="筛选SKU" size="small" style="width:160px;margin-left:8px"
					clearable prefix-icon="el-icon-search" />
			</div>
			<el-table :data="filteredTableData" style="width:100%;margin-top:12px" border stripe
				v-loading="isSending" @cell-dblclick="doubleClickCell" :row-style="getRowStyle"
				height="780">
				<el-table-column type="expand">
					<template slot-scope="scope">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="会员日备货"><span>{{ scope.row.会员日备货 }}</span></el-form-item>
							<el-form-item label="黑五备货"><span>{{ scope.row.黑五备货 }}</span></el-form-item>
							<el-form-item label="旺季备货"><span>{{ scope.row.旺季备货 }}</span></el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="本地父体" label="本地父体" min-width="140" />
				<el-table-column prop="本地品名" label="本地品名" min-width="150" />
				<el-table-column prop="FBA库存" label="FBA库存" width="90" />
				<el-table-column prop="FBA在途" label="FBA在途" width="90" />
				<el-table-column prop="本地库存" label="本地库存" width="90" sortable />
				<el-table-column prop="预计库存" label="预计库存" width="90">
					<template slot-scope="scope">
						<span>{{ scope.row.预计库存 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="采购在途" width="90">
					<template slot-scope="scope">
						{{ scope.row.预计库存 - scope.row.本地库存 }}
					</template>
				</el-table-column>
				<el-table-column label="销量数据" min-width="120" sortable prop="mergedSales"
					:sort-method="sortBy30Days">
					<template slot-scope="scope">
						<div class="sales-wrapper">
							<div class="sales-item">30天销量: {{ scope.row.三十天销量 }}</div>
							<div class="sales-item">14天销量: {{ scope.row.十四天销量 }}</div>
							<div class="sales-item">7天销量: {{ scope.row.七天销量 }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="安全天数" label="安全天数" width="100">
					<template slot-scope="scope">
						<div :style="{ backgroundColor: calculateSafetyStock(scope.row) < 70 ? 'yellow' : '' }">
							{{ calculateSafetyStock(scope.row) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sku" label="SKU" width="90" />
				<el-table-column prop="fnsku" label="FNSKU" width="100" />
				<el-table-column prop="每个ASIN采购数量" label="ASIN采购数" width="100" />
				<el-table-column prop="MSKU模版" label="MSKU模版" width="100" />
				<el-table-column prop="供应商" label="供应商" width="90" />
				<el-table-column label="采购数量" width="130">
					<template slot-scope="scope">
						<div class="purchase-wrapper">
							<div class="purchase-item">
								<span class="label">待采购:</span>
								<span class="value">{{ scope.row.预采购数量 }}</span>
							</div>
							<div class="purchase-item">
								<span class="label">已采购:</span>
								<span class="value">{{ scope.row.已采购数量 }}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="指定采购数量" label="指定采购数量" width="120" sortable>
					<template slot-scope="scope">
						<div v-if="!scope.row.edit" style="padding-top:5px;">{{ scope.row.指定采购数量 }}</div>
						<el-input v-else v-model="scope.row.指定采购数量" @blur="levelChange(scope.row)" size="small" />
					</template>
				</el-table-column>
				<el-table-column prop="备货建议" label="备货建议" width="100" sortable />
				<el-table-column prop="状态" label="状态" width="90" fixed="right">
					<template slot-scope="scope">
						<el-tag :type="productStatusType(scope.row.状态)" size="small" effect="plain">
							{{ scope.row.状态 }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="184" fixed="right">
					<template slot-scope="scope">
						<div class="action-btns">
							<el-dropdown @command="command => handleSelect_1(scope.row, command)">
								<el-button size="mini" :loading="isSending4" plain>编辑</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="编辑/详情">编辑/详情</el-dropdown-item>
									<el-dropdown-item command="正常">标记正常</el-dropdown-item>
									<el-dropdown-item command="后补">标记后补</el-dropdown-item>
									<el-dropdown-item command="待淘汰-正常移入">标记待淘汰-正常移入</el-dropdown-item>
									<el-dropdown-item command="淘汰移出">标记淘汰移出</el-dropdown-item>
									<!-- 暂时注释品名配置入口。 -->
									<!-- <el-dropdown-item command="品名配置" divided>品名配置</el-dropdown-item> -->
								</el-dropdown-menu>
							</el-dropdown>
							<!-- 暂时注释原有采购模式下拉框，后续需要时取消本段注释即可恢复。 -->
							<!--
							<el-dropdown v-if="scope.row.采购开关 === '不启用一键采购'" @command="command => selectPurchaseMode(scope.row, command)">
								<el-button size="mini" :loading="isSending5" plain>启动采购<i class="el-icon-arrow-down el-icon--right"></i></el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="normal">启动采购</el-dropdown-item>
									<el-dropdown-item command="new_asin">新建ASIN采购</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							-->
							<!-- 当前使用原有页面的单按钮入口。 -->
							<el-button v-if="scope.row.采购开关 === '不启用一键采购'" size="mini"
								:loading="isSending5" plain @click="caigou1(scope.row)">启动采购</el-button>
							<el-button size="mini" :loading="isSending5" plain type="danger"
								v-else-if="scope.row.采购开关 === '启用一键采购'" @click="caigou2(scope.row)">关闭采购</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="table-tip">
				Tip: 备货天数常态90天，90天计算正数则以120天计算；70天安全库存&gt;70时标黄 |
				<span style="color:red">采购: 指定采购数量→编辑选SKU/FNSKU→启动采购→一键采购</span>
			</div>
		</div>

		<!-- 暂时注释新建 ASIN 的可选超佣源 FNSKU 弹窗。 -->
		<!--
		<el-dialog title="新建 ASIN 选项" :visible.sync="sourceFnskuDialogVisible" width="620px"
			:close-on-click-modal="false">
			<el-alert type="info" :closable="false" show-icon
				title="可选择佣金费率大于 0.4 的源 FNSKU。选择后任务完成时会出现“超佣移出”按钮；不选择则只创建并采购，不产生移出动作。" />
			<el-form label-width="135px" size="small" style="margin-top:16px;">
				<el-form-item label="超佣源 FNSKU">
					<el-select v-model="sourceFnskuValue" clearable filterable placeholder="不选择（仅创建）"
						style="width:100%" :loading="sourceFnskuLoading">
						<el-option v-for="item in sourceFnskuOptions" :key="item.fnsku" :value="item.fnsku"
							:label="sourceFnskuLabel(item)" />
					</el-select>
					<div style="font-size:12px;color:#909399;margin-top:5px;">
						仅展示费率大于 0.4 的候选；库存查看与移出确认在任务面板完成。
					</div>
				</el-form-item>
				<el-form-item label="新建 MSKU 后缀">
					<el-radio-group v-model="sourceMskuSuffix" size="small">
						<el-radio-button label="T">T（发货）</el-radio-button>
						<el-radio-button label="C">C（跟卖）</el-radio-button>
						<el-radio-button label="CUSTOM">自定义</el-radio-button>
					</el-radio-group>
					<el-input v-if="sourceMskuSuffix === 'CUSTOM'" v-model="sourceMskuCustomSuffix"
						placeholder="如 HB，1-6 位字母或数字" maxlength="6" style="width:180px;margin-left:8px;" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="cancelSourceFnsku">取消</el-button>
				<el-button type="primary" @click="confirmSourceFnskuSelection">继续</el-button>
			</span>
		</el-dialog>
		-->
		<!-- 暂时注释任务面板组件。 -->
		<!--
		<task-panel-dialog :visible.sync="dialogTaskPanel" mode="create" :shop="filterText"
			show-move-actions />
		-->

		<!-- 编辑弹窗 -->
		<el-dialog :title="title" :visible="dialogVisible1" width="750px" :before-close="handleClose1">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form.建议方案" placement="top">
					<el-switch v-model="form.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">

				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.采购开关" placement="top">
					<el-switch v-model="form.采购开关" active-color="#13ce66" inactive-color="#ff4949" active-value="启用一键采购"
						inactive-text="采购开关" inactive-value="不启用一键采购">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="SKU" prop="SKU">
					<el-select v-model="form.sku" clearable placeholder="请选择SKU" style="width: 60%;" filterable
						@visible-change="clearSelect" ref="skuSelect">
						<el-option v-for="item in sku" :key="item.value" :label="item.SKU" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.是否使用新ASIN" placement="top">
					<el-switch v-model="form.是否使用新ASIN" active-color="#13ce66" inactive-color="#ff4949"
						active-value="工具自动生成新ASIN" inactive-text="是否使用新ASIN" inactive-value="工具使用目前选择FNSKU">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-if="form.是否使用新ASIN === '工具使用目前选择FNSKU'">
				<el-alert title="提示：FNSKU显示为红色是45%佣金，绿色则是15%佣金，原色则是无数据" type="info" :closable="false" show-icon>
				</el-alert>
				<el-form-item label="FNSKU" prop="FNSKU" style="margin-top: 10px;">
					<el-select v-model="form.fnsku" clearable placeholder="请选择FNSKU" style="width: 100%;" filterable
						allow-create default-first-option>
						<el-option v-for="item in fnsku" :key="item.value"
							:label="`${item.fnsku} (${item.value !== null && item.value !== undefined ? (item.value > 1 ? '0.00' : item.value.toFixed(2)) : '无数据'})`"
							:value="item.fnsku" :style="getRateStyle(item.value)" autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="仓库" prop="仓库" style="margin-top: 10px;">
					<el-select v-model="form.仓库" clearable placeholder="请选择仓库" style="width: 85%;" filterable>
						<el-option v-for="item in cangku" :key="item.value" :label="item.cangku" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-else-if="form.是否使用新ASIN === '工具自动生成新ASIN'">
				<el-form-item label="MSKU模版" prop="MSKU模版" label-width="100px">
					<el-input v-model="form.MSKU模版" placeholder="请输入MSKU模版" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="供应商" prop="供应商" label-width="100px">
					<el-input v-model="form.供应商" placeholder="请输入供应商" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="仓库" prop="仓库">
					<el-select v-model="form.仓库" clearable placeholder="请选择仓库" style="width: 70%;" filterable>
						<el-option v-for="item in cangku" :key="item.value" :label="item.cangku" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="update_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="title" :visible="dialogVisible2" width="40%" :before-close="handleClose2">
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form1.建议方案" placement="top">
					<el-switch v-model="form1.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form1.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form1.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form1.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form1.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form1.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form1.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="updateall_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="title" :visible="dialogVisible_zd" width="30%" :before-close="handleClose_zd">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="指定采购数量" prop="指定采购数量" label-width="100px">
					<el-input v-model="form.指定采购数量" placeholder="请输入指定采购数量" style="width: 70%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="zhiding_update" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 暂时注释品名配置弹窗，后续需要恢复时取消此注释。 -->
		<!--
		<pm-config-dialog
			:visible.sync="dialogPmConfigVisible"
			:parent="pmConfigMeta['本地父体']"
			:pm="pmConfigMeta['本地品名']"
			:shop="pmConfigMeta['店铺']"
			:msku="pmConfigMeta.msku"
			:warehouse.sync="pmConfigMeta.warehouse"
			:warehouses="cangku"
			@saved="onPmConfigSaved" />
		-->
	</div>
</template>

<script>
// 暂时关闭品名配置和任务面板组件；后续恢复对应入口时再取消注释。
// import PmConfigDialog from './PmConfigDialog.vue';
// import TaskPanelDialog from './TaskPanelDialog.vue';

export default {
	data() {
		return {
			searchForm: { shop: '', parentName: '' },
			isSending: false,
			isSending1: false,
			isSending2: false,
			isSending4: false,
			isSending5: false,
			isSending8: false,
			isSending18: false,
			pendingConfigRow: null,
			pendingPurchaseMode: null,
			// 新建 ASIN 的一次性选项（不落库 purchase_mode；源 FNSKU 写入任务元数据）
			sourceFnskuDialogVisible: false,
			sourceFnskuLoading: false,
			sourceFnskuRow: null,
			sourceFnskuOptions: [],
			sourceFnskuValue: '',
			sourceMskuSuffix: 'T',
			sourceMskuCustomSuffix: '',
			sourceFnskuContinue: null,
			isSending_in: false,
			isSending_register: false,
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisible2: false,
			dialogPmConfigVisible: false,
			dialogTaskPanel: false,
			taskList: [],
			activeTaskCount: 0,
			projectname: '',
			projectf: '',
			pmFilter: '',
			skuFilter: '',
			isButtonDisabled: false,
			tableKey: 0,
			fileData: [],
			allParentList: [],
			form: {},
			form1: {
				建议方案: '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存'
			},
			size: '',
			title: '',
			visible: false,
			tableData: [],
			tableData1: [],
			tableData2: [],
			tableData3: [],
			tableDataover: [],
			sku: [],
			fnsku: [],
			selectedDate: '',
			num1: 1,
			filters: [{ text: 'CoBak-US', value: 'CoBak-US' }, { text: 'CoBak-UK', value: 'CoBak-UK' }, { text: 'CoBak-SG', value: 'CoBak-SG' }, { text: 'CoBak-SE', value: 'CoBak-SE' }, { text: 'CoBak-PL', value: 'CoBak-PL' }, { text: 'CoBak-NL', value: 'CoBak-NL' }, { text: 'CoBak-MX', value: 'CoBak-MX' }, { text: 'CoBak-JP', value: 'CoBak-JP' }, { text: 'CoBak-IT', value: 'CoBak-IT' }, { text: 'CoBak-INDIA-IN', value: 'CoBak-INDIA-IN' }, { text: 'CoBak-FR', value: 'CoBak-FR' }, { text: 'CoBak-ES', value: 'CoBak-ES' }, { text: 'CoBak-DE', value: 'CoBak-DE' }, { text: 'CoBak-CA', value: 'CoBak-CA' }, { text: 'CoBak-BR', value: 'CoBak-BR' }, { text: 'CoBak Direct-BE', value: 'CoBak Direct-BE' }, { text: 'SMIFACE-CA', value: 'SMIFACE-CA' }, { text: 'SMIFACE-US', value: 'SMIFACE-US' }, { text: 'IDLEHANDS-US-CA', value: 'IDLEHANDS-US-CA' }, { text: 'iDLEHANDS-US-MX', value: 'iDLEHANDS-US-MX' }, { text: 'iDLEHANDS-US-US', value: 'iDLEHANDS-US-US' }, { text: 'European Union', value: 'EU' }],
			filterText: '',
			cangku: [{ text: '百汇办公室', value: '百汇办公室' }, { text: '工厂仓库', value: '工厂仓库' }, { text: '横中路仓库-加拿大', value: '横中路仓库-加拿大' }, { text: '横中路仓库-日本', value: '横中路仓库-日本' }, { text: '横中路仓库-美国', value: '横中路仓库-美国' }, { text: '横中路仓库-英国', value: '横中路仓库-英国' }, { text: '横中路仓库-德国', value: '横中路仓库-德国' }, { text: '淘汰-横中路成品仓库-加拿大', value: '淘汰-横中路成品仓库-加拿大' }, { text: '淘汰-横中路成品仓库-日本', value: '淘汰-横中路成品仓库-日本' }, { text: '淘汰-横中路成品仓库-美国', value: '淘汰-横中路成品仓库-美国' }, { text: '淘汰-横中路成品仓库-英国', value: '淘汰-横中路成品仓库-英国' }, { text: '批发仓库', value: '批发仓库' }, { text: '横中路仓库-印度', value: '横中路仓库-印度' }, { text: '横中路仓库-公共', value: '横中路仓库-公共' }],
			value: '',
			visible1: false,
			value1: [],
			value2: [],
			value3: [],
			test: [],
			formLabelWidth: '80px',
			timer: null,
			named: '',
			fand: 0,
			store: [],
			flagnum: 0,
			pmConfigMeta: { '本地父体': '', '本地品名': '', '店铺': '', msku: '', warehouse: '' },
		}
	},
	mounted() {
		// 暂时关闭任务面板的后台轮询，页面仅保留原有采购流程。
		// this._resumePolling()
		this.loadParentList()
	},
	computed: {
		parentOptions() {
			return (this.allParentList || []).map(p => ({
				text: p['本地父体'] || '', value: p['本地父体'] || ''
			}));
		},
		filteredTableData() {
			let data = this.tableData1 || [];
			const pmKw = this.pmFilter.toLowerCase();
			const skuKw = this.skuFilter.toLowerCase();
			if (pmKw) data = data.filter(r => (r['本地品名'] || '').toLowerCase().includes(pmKw));
			if (skuKw) data = data.filter(r => (r.sku || '').toLowerCase().includes(skuKw));
			return data;
		},
	},
	methods: {

		// === 页面加载 & 搜索 ===
		loadParentList() {
			this.$axios.get('/vue/auto_update/seller_asin_select', { params: {} }).then(res => {
				if (res.msg === 'success') {
					this.allParentList = res.data || [];
				}
			}).catch(() => { });
		},
		onShopChange() {
			this.filterText = this.searchForm.shop;
		},
		handleSearch() {
			const shop = this.searchForm.shop;
			const pname = this.searchForm.parentName;
			if (!shop) return this.$message.warning('请先选择店铺');
			if (!pname) return this.$message.warning('请先选择本地父体');
			this.filterText = shop;
			this.jojo(pname);
		},
		resetSearch() {
			this.searchForm = { shop: '', parentName: '' };
			this.filterText = '';
			this.tableData1 = [];
			this.projectf = '';
		},

		clearSelect(changed) {
			// 1. 清空已选择的值

			if (changed) {
				this.sku = []
				this.select_sku(this.title)
			}
			else {
				this.sku = [];
			}



		},

		sortBy30Days(a, b) {
			// a和b是表格中的两行数据
			// 升序：a - b；降序：b - a（方法内部会根据点击自动切换）
			return a.三十天销量 - b.三十天销量;
		},






		getRowStyle(row) {
			if (this.calculateSafetyStock(row.row) < 70) {
				return { backgroundColor: '#FFF9C4' };
			}
			return {};
		},
		calculateSafetyStock(row) {
			if (!row['三十天销量'] || row['三十天销量'] === 0) return 0;
			const safetyStock = (row['FBA库存'] + row['FBA在途']) / row['三十天销量'] * 30;
			return Math.round(safetyStock);
		},
		productStatusType(status) {
			const m = {
				'正常': 'success', '后补': 'danger',
				'待淘汰-正常移入': 'warning', '淘汰移出': 'warning',
			};
			return m[status] || 'info';
		},
		handleSelect_1(row, command) {
			console.log('选中行内容:', row);
			console.log('选中选项:', command);
			if (command == '编辑/详情') {
				this.update(row)
			} else if (command == '指定采购数量') {
				this.zhiding(row)
			} else {
				this.test = []
				this.test = row
				this.update_state_1(row, command)
			}
		},
		getRateStyle(value) {
			if (value === null || value === undefined || value === 0) {
				return {};
			}

			if (value > 0.4) {
				return { color: '#f56c6c' }; // 红色
			} else if (value > 0.1 && value <= 0.4) {
				return { color: '#67c23a' }; // 绿色
			}

			return {}; // 默认颜色
		},
		update_state_1(row, state) {
			this.test.状态 = state
			this.$axios.post('/vue/parent_calculate/update_state_1', { row: row, state: state }).then(res => {
				console.log(res);
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 20000
					});
				}
			}).catch(error => {
				console.log(error)
			})
		},
		doubleClickCell(row) {
			this.$set(row, "edit", true)
		},
		levelChange(row) {
			this.$set(row, "edit", false)
			this.$axios.post('/vue/parent_calculate/zhiding_update', row).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
				}
			})
				.catch(error => {
					console.log(error)
				})
		},
		open(male_parent) {
			this.$confirm('此操作将收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_collect', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		open1(male_parent) {
			this.$confirm('此操作将取消收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '取消收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_unbind', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		isInSeason(type) {
			const today = new Date();
			const year = today.getFullYear();
			let startDate, endDate;
			if (type === '旺季') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '黑五') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '会员日') {
				const startDate1 = new Date(`${year}-04-15`)
				const endDate1 = new Date(`${year}-07-15`)
				const startDate2 = new Date(`${year}-07-30`)
				const endDate2 = new Date(`${year}-10-15`)
				return (today >= startDate1 && today <= endDate1) || (today >= startDate2 && today <= endDate2);
			}
			return today >= startDate && today <= endDate;
		},
		// 批量计算备货建议并存储到行数据中（用于排序）
		calculateAllSuggestions() {
			if (this.tableData1 && this.tableData1.length > 0) {
				this.tableData1.forEach(row => {
					row.备货建议 = this.calculateSuggestion(row);
				});
			}
		},

		calculateSuggestion(row) {
			console.log('计算备货建议的行数据:', row);
			let baseDays = row.备货天数;  // 默认使用备货天数
			// 将建议方案中的全角括号统一转为半角，避免批量编辑/单行编辑保存的括号不一致导致匹配失败
			const plan = String(row.建议方案 || '').replace(/（/g, '(').replace(/）/g, ')');
			// 根据不同的建议方案计算备货建议
			let suggestion;
			if (plan === '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 * baseDays
					+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
					+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
					+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 * baseDays
						+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
						+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
						+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			} else if (plan === '30天销量/30*(备货天数+旺季备货天数+黑五备货天数+会员日备货天数)-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 *
					(baseDays +
						(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
						(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
						(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 *
						(baseDays +
							(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
							(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
							(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			}
			// 如果没有匹配的建议方案，检查是否所有值都为0
			if (Number(row.会员日备货) === 0 && Number(row.黑五备货) === 0 &&
				Number(row.旺季备货) === 0 && Number(row.备货天数) === 0) {
				return 0;
			}
			return suggestion || 0;
		},
		init() {
			this.loadParentList();
		},

		check_care_parent() {
			this.loadParentList();
		},



		select_sku(pm) {
			this.sku = []
			this.$axios.post('/vue/parent_calculate/select_sku', { pm: pm }).then(res => {
				if (res.msg == 'success') {
					this.sku = res.data
				} else {
					console.log(res.data)
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
			})
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		update(row) {
			this.title = row.本地品名
			this.form = {}
			this.form = row
			this.dialogVisible1 = true
			this.select_fnsku(row.本地品名, this.filterText)
		},
		zhiding(row) {
			this.title = row.本地品名
			this.form = {}
			this.fnsku = {}
			this.sku = {}
			this.form = row
			this.dialogVisible_zd = true
		},
		select_fnsku(pm, shop) {
			// 如果选择的是欧盟店铺，则实际使用德国店铺查询
			const actualShop = shop === 'EU' ? 'CoBak-DE' : shop;
			this.$axios.post('/vue/parent_calculate/select_fnsku', { pm: pm, shop: actualShop })
				.then(res => {
					if (res.msg == 'success') {
						this.fnsku = res.data
						this.dialogVisible1 = true;
						console.log('点击编辑窗口弹出得fnsku有这些', this.fnsku)
					} else {
						console.log(res.data)
					}
					this.select_sku(pm)
				}).catch(error => {
					console.log(error)
					alert('发生错误: ' + error.message)
			})
		},
		/* 暂时关闭新建 ASIN 采购的源 FNSKU 和后缀配置流程。
		sourceFnskuLabel(item) {
			const fee = item && item.fee_ratio !== null && item.fee_ratio !== undefined
				? Number(item.fee_ratio).toFixed(2) : '无数据'
			return (item.fnsku || '') + '（佣金 ' + fee + '，ASIN ' + (item.asin || '-') + '）'
		},
		openSourceFnskuDialog(row, continueHandler) {
			this.sourceFnskuRow = row
			this.sourceFnskuValue = row.source_fnsku || ''
			this.sourceMskuSuffix = row.msku_suffix || 'T'
			this.sourceMskuCustomSuffix = row.msku_custom_suffix || ''
			this.sourceFnskuOptions = []
			this.sourceFnskuContinue = continueHandler
			this.sourceFnskuDialogVisible = true
			const actualShop = (row['店铺'] || this.filterText) === 'EU' ? 'CoBak-DE' : (row['店铺'] || this.filterText)
			this.sourceFnskuLoading = true
			this.$axios.post('/vue/parent_calculate/select_fnsku', {
				pm: row['本地品名'], shop: actualShop
			}).then(res => {
				if (res.msg === 'success') {
					this.sourceFnskuOptions = (res.data || []).filter(item => {
						const fee = Number(item.fee_ratio !== undefined ? item.fee_ratio : item.value)
						return Number.isFinite(fee) && fee > 0.4
					})
				}
			}).catch(() => {
				this.sourceFnskuOptions = []
			}).finally(() => {
				this.sourceFnskuLoading = false
			})
		},
		cancelSourceFnsku() {
			this.sourceFnskuDialogVisible = false
			this.sourceFnskuContinue = null
		},
		confirmSourceFnskuSelection() {
			const row = this.sourceFnskuRow
			if (!row) return this.cancelSourceFnsku()
			if (this.sourceMskuSuffix === 'CUSTOM'
				&& !/^[A-Za-z0-9]{1,6}$/.test((this.sourceMskuCustomSuffix || '').trim())) {
				this.$message.warning('MSKU 后缀需为 1-6 位英文字母或数字')
				return
			}
			this.$set(row, 'source_fnsku', this.sourceFnskuValue || '')
			const selected = this.sourceFnskuOptions.find(item => item.fnsku === this.sourceFnskuValue)
			this.$set(row, 'source_asin', selected ? (selected.asin || '') : '')
			this.$set(row, 'source_fee_ratio', selected ? (selected.fee_ratio !== undefined ? selected.fee_ratio : selected.value) : null)
			this.$set(row, 'msku_suffix', this.sourceMskuSuffix === 'CUSTOM'
				? this.sourceMskuCustomSuffix : this.sourceMskuSuffix)
			this.$set(row, 'msku_custom_suffix', this.sourceMskuCustomSuffix)
			const handler = this.sourceFnskuContinue
			this.cancelSourceFnsku()
			if (handler) handler()
		},
		*/
		auto_caigou(purchaseModes = {}, rows = null, sourceFnskus = {}, sourceSuffixes = {}) {
			this.isSending18 = true
			const purchaseRows = rows || this.tableData3.filter(row => row['采购开关'] === '启用一键采购')
			console.log('[auto_caigou] 提交数据:', { rows: purchaseRows, purchase_modes: purchaseModes, source_fnskus: sourceFnskus, source_suffixes: sourceSuffixes })
			this.$axios.post('/vue/parent_calculate/auto_caigou', {
				rows: purchaseRows,
				purchase_modes: purchaseModes,
				source_fnskus: sourceFnskus,
				source_suffixes: sourceSuffixes,
			}).then(res => {
				if (res.msg == 'success') {
					alert(res.data)
					this.isSending18 = false
				} else {
					alert('发生错误:==' + res.data)
					this.isSending18 = false
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
				this.isSending18 = false
			})
		},
		handlePreview(file) {
			console.log(file);
		},
		handleClose() {
			this.dialogVisible = false
			this.init()
		},
		handleClose1() {
			this.dialogVisible1 = false
			this.jojo1(this.form.本地父体)
		},
		handleClose2() {
			this.dialogVisible2 = false
			this.jojo1(this.projectf)
		},
		handleClose_zd() {
			this.dialogVisible_zd = false
		},
		reset() {
			let id = undefined
			if ('id' in this.form) {
				id = this.form.id
			}
			this.form = {}
			if (id != undefined) this.form.id = id
		},
		jojo(project) {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: project, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.tableData1 = res.data
						console.log('/parent_select_child返回的数据', this.tableData1)
						this.projectf = project
						this.calculateAllSuggestions(); // 计算备货建议用于排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		jojo1(project) {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: project, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.tableData1 = res.data
						this.calculateAllSuggestions(); // 计算备货建议用于排序
						this.projectf = project
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		jojo2() {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				const purchaseModes = {}
				const sourceFnskus = {}
				const sourceSuffixes = {}
				this.tableData1.forEach(row => {
					if (row.purchase_mode) {
						const key = `${row['本地父体']}|${row['本地品名']}|${row['店铺']}`
						const nameKey = `${row['本地父体']}|${row['本地品名']}`
						purchaseModes[key] = row.purchase_mode
						purchaseModes[nameKey] = row.purchase_mode
						if (row.source_fnsku) {
							sourceFnskus[key] = row.source_fnsku
							sourceFnskus[nameKey] = row.source_fnsku
						}
						if (row.msku_suffix) {
							sourceSuffixes[key] = row.msku_suffix
							sourceSuffixes[nameKey] = row.msku_suffix
						}
					}
				})
				this.$axios.post('/vue/parent_calculate/parent_select_child', { name: this.projectf, shop: this.filterText }).then(res => {
					console.log(res);
					if (res.msg == 'success') {
						this.tableData3 = res.data.map(row => {
							const key = `${row['本地父体']}|${row['本地品名']}|${row['店铺']}`
							const nameKey = `${row['本地父体']}|${row['本地品名']}`
							const mode = purchaseModes[key] || purchaseModes[nameKey]
							const sourceFnsku = sourceFnskus[key] || sourceFnskus[nameKey] || ''
							const sourceSuffix = sourceSuffixes[key] || sourceSuffixes[nameKey] || ''
							return mode ? { ...row, purchase_mode: mode, source_fnsku: sourceFnsku, msku_suffix: sourceSuffix } : row
						})
						const selectedRows = this.tableData3.filter(row => row.purchase_mode)
						this.auto_caigou(purchaseModes, selectedRows, sourceFnskus, sourceSuffixes)
						// this.applySorting(); // 应用排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
		caigou1(row) {
			this.selectPurchaseMode(row, 'normal')
		},
		caigou2(row) {
			if (!row.sku) {
				this.$message.warning('请先选择SKU')
				return
			}
			this.isSending5 = true
			this.$axios.post('/vue/parent_calculate/caigou2', row).then(res => {
				if (res.code === 200) {
					this.$set(row, '采购开关', '不启用一键采购')
					this.$notify.success({ title: '成功', message: res.msg, duration: 2000 })
				} else {
					this.$notify.error({ title: '错误', message: res.msg, duration: 2000 })
				}
			}).catch(error => {
				this.$notify.error({ title: '错误', message: '关闭采购失败: ' + error, duration: 3000 })
			}).finally(() => {
				this.isSending5 = false
			})
		},
		selectPurchaseMode(row, mode) {
			if (!row.sku) {
				this.$message.warning('请先选择SKU')
				return
			}
			if (mode === 'normal' && !row.fnsku) {
				this.$message.warning('普通采购请先选择FNSKU')
				return
			}
		// 暂时只允许原有的普通启动采购，屏蔽新建 ASIN 采购分支。
		if (mode !== 'normal') {
				return
			}
		this.startPurchase(row, 'normal')
		},
		startPurchase(row, mode) {
			this.isSending5 = true
			this.$axios.post('/vue/parent_calculate/caigou1', { ...row, purchase_mode: mode }).then(res => {
				if (res.code === 200) {
					this.$set(row, '采购开关', '启用一键采购')
					this.$set(row, 'purchase_mode', mode)
					this.$notify.success({ title: '成功', message: res.msg, duration: 2000 })
				} else {
					this.$notify.error({ title: '错误', message: res.msg, duration: 2000 })
				}
			}).catch(error => {
				this.$notify.error({ title: '错误', message: '启动采购失败: ' + error, duration: 3000 })
			}).finally(() => {
				this.isSending5 = false
			})
		},
		validateProcurementMethod(row) {
			if (!row.sku) {
				this.$message.warning('请先选择SKU')
				return false
			}
			return true
		},
		/* 暂时关闭编辑下拉框中的品名配置回调。
		openPmConfig(row) {
			this.pmConfigMeta = {
				'本地父体': row['本地父体'] || '',
				'本地品名': row['本地品名'] || '',
				'店铺': row['店铺'] || this.filterText || '',
				msku: row.msku || '',
				warehouse: row['仓库'] || '',
			}
			this.dialogPmConfigVisible = true
		},
		onPmConfigSaved() {
			this.dialogPmConfigVisible = false
			if (this.pendingConfigRow && this.pendingPurchaseMode === 'new_asin') {
				const row = this.pendingConfigRow
				this.$set(row, '仓库', this.pmConfigMeta.warehouse)
				this.pendingConfigRow = null
				this.pendingPurchaseMode = null
				this.openSourceFnskuDialog(row, () => this.startPurchase(row, 'new_asin'))
			}
		},
		*/
		/* 暂时关闭任务面板及其前端轮询逻辑。
		// 轮询任务状态（单个任务）
		_pollTask(taskId, action) {
			const actionName = action === 'create_and_procure' ? '创建并采购' : '创建'
			const check = () => {
				this.$axios.get('/vue/parent_calculate/task_status', { params: { task_id: taskId } }).then(res => {
					if (res.code != 200) return
					const task = res.data
					const st = task.status
					// 同步更新 taskList 中该条任务
					this._upsertTaskToList(task)
					if (st === 'failed') {
						this.$notify.error({ title: '创建失败', message: task.error || '未知错误', duration: 0 })
						return
					}
					if (st === 'complete') {
						const asin = task.new_asin || ''
						const fnsku = task.new_fnsku || ''
						this.$notify.success({
							title: actionName + '完成',
							message: 'ASIN: ' + asin + '\nFNSKU: ' + fnsku,
							duration: 0
						})
						this._refreshData()
						return
					}
					const msg = task.status_msg || task.step || st
					console.log('[' + taskId + '] ' + msg)
					setTimeout(check, 5000)
				}).catch(() => {
					setTimeout(check, 5000)
				})
			}
			setTimeout(check, 3000)
		},
		// 将任务插入或更新到 taskList
		_upsertTaskToList(task) {
			const idx = this.taskList.findIndex(t => t.task_id === task.task_id)
			if (idx >= 0) {
				this.$set(this.taskList, idx, task)
			} else {
				this.taskList.unshift(task)
			}
			this._updateActiveCount()
		},
		// 刷新数据
		_refreshData() {
			if (this.filterText && this.projectf) {
				this.jojo(this.projectf);
			}
		},
		allupdate() {
			if (this.filterText != '' && this.projectf != '') {
				this.title = '批量编辑'
				this.dialogVisible2 = true
			} else {
				alert('请先选择父体和店铺')
			}
		},
		// 打开任务面板弹窗
		openTaskPanel() {
			this.dialogTaskPanel = true
			this._fetchTasks()
		},
		// 拉取任务列表（打开任务面板时调用）
		_fetchTasks() {
			this.$axios.get('/vue/parent_calculate/task_list').then(res => {
				if (res.code == 200) {
					this.taskList = (res.data || []).filter(t =>
						t.action !== 'move_in' && t.action !== 'move_out'
					)
					this._updateActiveCount()
				}
			}).catch(() => {})
		},
		// 页面加载时恢复进行中任务的轮询
		_resumePolling() {
			this.$axios.get('/vue/parent_calculate/task_list').then(res => {
				if (res.code == 200) {
					const tasks = (res.data || []).filter(t =>
						t.action !== 'move_in' && t.action !== 'move_out'
					)
					this.taskList = tasks
					this._updateActiveCount()
					const activeStatuses = ['pending', 'publishing', 'phase1_done', 'phase2_done', 'procuring']
					tasks.forEach(task => {
						if (activeStatuses.includes(task.status)) {
							this._pollTask(task.task_id, task.action || 'create_only')
						}
					})
				}
			}).catch(() => {})
		},
		// 统计进行中的任务数（排除 complete/failed）
		_updateActiveCount() {
			const activeStatuses = ['pending', 'publishing', 'phase1_done', 'phase2_done', 'procuring']
			this.activeTaskCount = this.taskList.filter(t => activeStatuses.includes(t.status)).length
		},
		*/
		update_data() {
			if (this.form.MSKU模版.length > 23) {
				alert('MSKU模版字数超过23，请修改后再提交')
			} else if (this.form.采购开关 == '启用一键采购') {
				if (this.form.sku == '') {
					alert('请先选择sku')
				} else if (this.form.是否使用新ASIN == '工具使用目前选择FNSKU') {
					if (this.form.fnsku == '' || this.form.仓库 == '') {
						alert('请检查fnsku/仓库是否已选择')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				} else if (this.form.是否使用新ASIN == '工具自动生成新ASIN') {
					if (this.form.MSKU模版 == '' || this.form.供应商 == '' || this.form.仓库 == '' || Number(this.form.指定采购数量) <= 0) {
						alert('请检查指定采购数量/MSKU模版/供应商/仓库是否填写完整')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				}
			} else {
				this.isSending2 = true
				console.log(this.form);
				this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
					if (res.code == 200) {
						let _this = this
						this.$notify.success({
							title: '成功',
							message: res.msg,
							duration: 2000,
							onClose: function () { _this.handleClose1() }
						});
						this.isSending2 = false
					} else {
						this.$notify.error({
							title: '错误',
							message: res.msg,
							duration: 2000
						});
						this.isSending2 = false
					}
				})
					.catch(error => {
						console.log(error)
						alert('发生错误:==' + '请检查内容是否填写完整')
						this.isSending2 = false
					})
			}
		},
		change_all() {
			if (this.projectf == '') {
				alert('请先选择父体')
			} else {
				this.$confirm('是否要将备货建议全部填入指定采购数量', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '置换成功!'
					})
					this.$axios.post(`/vue/parent_calculate/change_all`, this.tableData1).then(res => {
						console.log(res)
						if (res.msg == 'success') {
							this.jojo(this.projectf)
						}
						// this.applySorting(); // 应用排序
					}).catch(error => {
						console.log(error)
					})
				})
			}
		},
		updateall_data() {
			this.isSending2 = true
			console.log(this.form1);
			this.$axios.post('/vue/parent_calculate/update_alldata', { form: this.form1, data: this.tableData1 }).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		zhiding_update() {
			this.isSending2 = true
			this.$axios.post('/vue/parent_calculate/zhiding_update', this.form).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		select_pm() {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.isSending8 = true
				this.$axios.post(`/vue/parent_calculate/select_pm`, { input: this.select_input, input2: this.select_input2, shop: this.filterText }).then(res => {
					// 调试：查看后端返回的完整数据
					console.log('后端返回的完整res:', res)
					console.log('后端返回的res.data:', res.data)
					this.tableData1 = res.data
					console.log('select_pm返回的数据', this.tableData1)
					this.calculateAllSuggestions(); // 计算备货建议用于排序
					this.isSending8 = false
				}).catch(error => {
					alert(error)
					console.log(error)
					this.isSending8 = false
				})
			}
		},
	},
}
</script>

<style>
.main {
	height: 100%;
	width: 100%;
	background: #f8f9fa;
	min-height: 100vh;
}

.operation-bar {
	background: #fff;
	padding: 12px 20px;
	border-radius: 4px;
	margin-bottom: 16px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.1);
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
}

.search-form {
	display: flex;
	align-items: center;
}
.search-form .el-form-item {
	margin-bottom: 0;
	margin-right: 12px;
}

.action-btns-group {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
}

.table-area {
	background: #fff;
	padding: 16px 20px;
	border-radius: 4px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.1);
	overflow: hidden;
}

.table-header-bar {
	display: flex;
	align-items: center;
	margin-bottom: 4px;
}
.table-title {
	font-size: 15px;
	font-weight: 600;
	color: #303133;
	margin-right: 20px;
}

.table-tip {
	white-space: nowrap;
	color: #E6A23C;
	font-size: 12px;
	margin-top: 8px;
	padding: 4px 0;
}

.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 100%;
}
</style>

<style scoped="scoped">
.purchase-wrapper {
	padding: 5px 0;
	text-align: right;
	line-height: 1.5;
}
.purchase-item {
	font-size: 13px;
	display: inline-block;
	width: 100%;
}
.label {
	color: #909399;
	margin-right: 4px;
}
.value {
	color: #303133;
	font-weight: 500;
}
.purchase-item:first-child {
	margin-bottom: 3px;
}

.sales-wrapper {
	padding: 5px 0;
	line-height: 1.5;
}
.sales-item {
	font-size: 13px;
	color: #606266;
}
.sales-item:not(:last-child) {
	border-bottom: 1px dashed #eee;
	margin-bottom: 3px;
	padding-bottom: 3px;
}

.action-btns {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-wrap: nowrap;
}

.config-layout {
	display: flex;
	gap: 20px;
	align-items: flex-start;
}
.config-left {
	width: 340px;
	flex-shrink: 0;
	border-right: 1px solid #ebeef5;
	padding-right: 20px;
}
.config-right {
	flex: 1;
	min-width: 0;
	max-height: 560px;
	overflow-y: auto;
	padding-left: 6px;
}
.config-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 8px 28px;
	font-size: 13px;
	color: #606266;
	background: #f5f7fa;
	border-radius: 4px;
	padding: 10px 14px;
	margin-bottom: 12px;
}
.meta-item {
	display: inline-flex;
	align-items: center;
}
.meta-label {
	color: #909399;
	margin-right: 6px;
}
.config-empty {
	color: #909399;
	font-size: 13px;
	padding: 12px 0;
}

.dims-row {
	display: flex;
	align-items: center;
	gap: 6px;
}
.dims-x {
	color: #909399;
}
.dims-unit {
	margin-left: 2px;
	font-size: 12px;
	color: #909399;
	white-space: nowrap;
}
</style>
